// Domain-level constants for the Inquiries workspace. Kept separate from the
// Leads constants because the shape and vocabulary differ (no campaigns, no
// sequence, no enrollment) even though the visual language is shared.

export const INQUIRY_TYPES = ["Guest", "Host", "Driver", "Concierge", "Other"];

export const TYPE_LABELS = {
  Guest: "Guest",
  Host: "Host",
  Driver: "Driver",
  Concierge: "Concierge",
  Other: "Other",
};

// Dot colors mirror the Leads workspace palette (indigo family + zinc neutrals
// + warm accent) rather than the rainbow badges the old view used.
export const TYPE_TONE = {
  Guest: {
    dot: "bg-amber-500",
    chip: "bg-amber-50 text-amber-700 ring-amber-200",
  },
  Host: {
    dot: "bg-indigo-500",
    chip: "bg-indigo-50 text-indigo-700 ring-indigo-200",
  },
  Driver: {
    dot: "bg-violet-500",
    chip: "bg-violet-50 text-violet-700 ring-violet-200",
  },
  Concierge: {
    dot: "bg-emerald-500",
    chip: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  },
  Other: {
    dot: "bg-zinc-400",
    chip: "bg-zinc-100 text-zinc-700 ring-zinc-200",
  },
};

// Smart-views drive the left-rail navigation and keyboard shortcuts 1-5.
// IDs are referenced by utils + the dashboard shell; don't rename without
// updating both.
export const SMART_VIEWS = [
  {
    id: "today",
    label: "Today",
    hint: "New and awaiting a reply today",
    shortcut: "1",
  },
  {
    id: "awaiting",
    label: "Awaiting reply",
    hint: "Oldest unreplied first",
    shortcut: "2",
  },
  {
    id: "replied",
    label: "Replied",
    hint: "Handled — still open",
    shortcut: "3",
  },
  {
    id: "closed",
    label: "Closed",
    hint: "Archived inquiries",
    shortcut: "4",
  },
  {
    id: "all",
    label: "All inquiries",
    hint: "No status filter",
    shortcut: "5",
  },
];

// Thresholds for urgency shading on unreplied inquiries (in hours). These
// inform the ledger row accent and the MetricStrip breakdown.
export const URGENCY_BUCKETS = [
  { id: "overdue", label: ">1 day", minHours: 24, tone: "red" },
  { id: "stale", label: "4h – 1d", minHours: 4, tone: "amber" },
  { id: "fresh", label: "1h – 4h", minHours: 1, tone: "indigo" },
  { id: "new", label: "<1h", minHours: 0, tone: "emerald" },
];

export const DEFAULT_UNRESOLVED_SIG_WARNING =
  "Signature not set — save one in Settings → Email signature.";
